import { render, staticRenderFns } from "./CardTransaction.vue?vue&type=template&id=129aed69&"
import script from "./CardTransaction.vue?vue&type=script&lang=js&"
export * from "./CardTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports